import { render, staticRenderFns } from "./ExpenseCode.vue?vue&type=template&id=67c49814&"
import script from "./ExpenseCode.vue?vue&type=script&lang=js&"
export * from "./ExpenseCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports